<!-- Above the abstract of an item that builds on earlier recordings (useEventVideos
     getViewingNote): secondary guidance, muted, smaller and italic; its links keep the link colour.
     - one video: "Watch the 85-minute video before this summary talk (Learn More)."
     - several: "Watch Brady, Samuel and Vera’s videos before this breakout session (Learn
       More).", each name linking to that speaker's video; "Learn More" to the format's
       explanation. -->
<template>
  <p class="viewingNote">
    Watch
    <template v-if="note.videos.length === 1">
      the
      <router-link :to="getVideoPath(note.videos[0])">{{
        getVideoLabel(note.videos[0])
      }}</router-link>
    </template>
    <template v-else>
      <template v-for="(speaker, index) in speakerLinks" :key="index"
      ><span v-if="index">{{ index === speakerLinks.length - 1 ? " and " : ", " }}</span
      ><router-link :to="getVideoPath(speaker)">{{ speaker.firstName }}</router-link></template
      >’s videos
    </template>
    before this {{ note.kind }} (<router-link :to="learnMorePath">Learn More</router-link>).
  </p>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  note: {type: Object, required: true},
  learnMorePath: {type: [String, Object], required: true} // the format's explanation
});

function getVideoPath(video) {
  return `/Videos/${video.hash}`;
}

function getVideoLabel(video) {
  return video.minutes ? `${video.minutes}-minute video` : "video";
}

function getFirstName(name) {
  return String(name || "").trim().split(/\s+/)[0];
}

// each speaker (in program order) with their video: "Martin and Christian’s videos"
const speakerLinks = computed(() => {
  return props.note.videos.flatMap((video) => {
    return video.speakers.map((name) => ({firstName: getFirstName(name), hash: video.hash}));
  });
});
</script>

<style scoped>
p.viewingNote {
  margin-bottom: 0.25em; /* ▶ EDIT HERE: gap between the note and the abstract below it */
  font-size: 0.9em;
  font-style: italic;
  color: var(--text-color-less-subtle);
}
p.viewingNote a {
  white-space: nowrap; /* "85-minute video" never splits across lines */
}
</style>
